<template>
    <div>
        <div class="modal-header">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
            <h4 id="statusLegendLabel" class="modal-title forgot-title">{{this.callId ? 'Edit' : 'New'}} Call</h4>
        </div>

        <template v-if="!loading">
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                        <legend class="text-semibold generic-legend"><i class="fas fa-building position-left"></i> Company Information</legend>
                        <call-details-company-info :call="call" :required-fields="requiredFields" :field-errors="fieldErrors" :read-only="readOnly || this.callId > 0" :companies="companies"></call-details-company-info>

                        <legend class="text-semibold generic-legend"><i class="fas fa-phone position-left"></i> Call Information</legend>
                        <call-details-call-info :call="call" :required-fields="requiredFields" :field-errors="fieldErrors" :read-only="readOnly"></call-details-call-info>

                        <legend class="text-semibold generic-legend"><i class="fas fa-car-alt position-left"></i> Vehicle Information</legend>
                        <call-details-vehicle-info :call="call" :required-fields="requiredFields" :field-errors="fieldErrors" :read-only="readOnly"></call-details-vehicle-info>

                        <legend class="text-semibold generic-legend"><i class="fas fa-user position-left"></i> Owner Information</legend>
                        <call-details-owner-info :call="call" :required-fields="requiredFields" :field-errors="fieldErrors" :read-only="readOnly"></call-details-owner-info>

                        <legend class="text-semibold generic-legend"><i class="fas fa-paperclip position-left"></i> Other</legend>
                        <call-details-other-info :call="call" :required-fields="requiredFields" :field-errors="fieldErrors" :read-only="readOnly"></call-details-other-info>

                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-xs-6 text-left">
                        <button type="button" class="btn btn-danger modal-button" v-if="(callId && !readOnly && call.CallStatus < 6)" @click="cancelConfirm()">Cancel Call</button>
                    </div>
                    <div class="col-xs-6 text-right">
                        <button type="button" class="btn btn-default modal-button" v-if="!readOnly" @click="save()">{{this.callId ? 'Update' : 'Create New'}} Call</button>
                        <button type="submit" class="btn btn-default close-button" data-dismiss="modal">{{readOnly ? 'Close' : 'Cancel'}}</button>
                    </div>
                </div>
            </div>
        </template>
        <div v-if="loading" class="loading">
            <p><i class="fal fa-spinner fa-spin fa-2x"></i></p>
            <p>Loading</p>
        </div>

    </div>
</template>

<style lang="scss" scoped>

    .loading {
        margin: 80px 0px;
        font-size: 20px;
        font-weight: bold;
        text-align: center;
    }

</style>

<script>

    import CallDetailsCompanyInfo from './CallDetailsCompanyInfo';
    import CallDetailsCallInfo from './CallDetailsCallInfo';
    import CallDetailsVehicleInfo from './CallDetailsVehicleInfo';
    import CallDetailsOwnerInfo from './CallDetailsOwnerInfo';
    import CallDetailsOtherInfo from './CallDetailsOtherInfo';

    export default {
        components: {
            CallDetailsCompanyInfo,
            CallDetailsCallInfo,
            CallDetailsVehicleInfo,
            CallDetailsOwnerInfo,
            CallDetailsOtherInfo,
        },

        data() {
            return {
                callId: null,
                call: null,
                fieldErrors: {
                    VIN: [],
                    VehiclePlate: [],
                    Location: [],
                },
                requiredFields: {
                    Location: true,
                },

                companies: [],

                loading: true,
                error: false,

                readOnly: false,

            };
        },

        created() {
            EventBus.listen('call-details-modal-load', this.load);
        },

        destroyed() {
            EventBus.stopListening('call-details-modal-load', this.load);
        },

        methods: {

            load(callId) {
                this.loading = true;
                this.error = false;
                this.callId = (callId ? callId : null);

                Ajax.get(`call-details${this.callId ? `/${this.callId}` : ''}`)
                    .then((response) => {

                        this.companies.splice(0, this.companies.length);
                        response.data.companies.forEach(company => { this.companies.push(company) });

                        this.callId = (callId ? callId : null);
                        this.call = new Call(response.data.call);
                        this.loading = false;

                        this.readOnly = (this.call.CallStatus === 7);

                    })
                    .catch((response) => {
                        this.loading = false;
                        this.error = true;

                        this.call = new Call();
                        this.call.LocationLatitude = 0;
                        this.call.LocationLongitude = 0;
                        this.call.DestinationLatitude = 0;
                        this.call.DestinationLongitude = 0;

                        if (response) {
                            notifier.error('Failed to load neccisary form data. Please try again.');
                        }
                    });

            },

            save() {

                if (this.readOnly) {
                    return;
                }

                if (!this.valid()) {
                    console.log('Invalid!');
                    return;
                }

                notifier.asyncBlock(
                    Ajax.post(`call-details${this.callId ? `/${this.callId}` : ''}`, { call: this.call }),
                    (response) => {
                        notifier.success('Call saved successfully');
                        EventBus.fire('call-list-update');
                        this.close();
                    },
                    (error) => {
                        if (error) {
                            if (error.response.data.message) {
                                const message = `<p>An error occured while trying to save the call:</p><p>${error.response.data.message}</p>`;
                                notifier.alert(message);
                            } else {
                                notifier.alert('There was an error saving the call. Please try again.');
                            }
                        }
                    },
                    'Saving Call',
                );


            },

            cancelConfirm() {
                if (this.readOnly) {
                    return;
                }

                notifier.confirm(
                    'Are you sure you would like to cancel this call?',
                    this.cancel,
                );
            },

            cancel() {
                if (this.readOnly) {
                    return;
                }

                notifier.asyncBlock(
                    Ajax.delete(`call-details/${this.callId}`),
                    () => {
                        notifier.success('Call canceled successfully');
                        EventBus.fire('call-list-update');
                        this.close();
                    },
                    (error) => {
                        if (error) {
                            if (error.response.data.message) {
                                const message = `<p>An error occured while trying to save the call:</p><p>${error.response.data.message}</p>`;
                                notifier.alert(message);
                            } else {
                                notifier.alert('There was an error canceling the call. Please try again.');
                            }
                        }
                    },
                    'Canceling Call'
                );
            },

            close() {
                this.$emit('close-modal');
            },

            valid() {

                let valid = true;

                _.forOwn(this.fieldErrors, (value, field) => {
                    this.fieldErrors[field] = false;
                });

                _.forOwn(this.requiredFields, (isRequired, field) => {
                    if ((isRequired) && (!this.call[field])) {
                        this.fieldErrors[field] = true;
                        valid = false;
                    }
                });

                return valid;

            },

        }

    }
</script>

